import React from 'react';
import {VerdocsAuth} from '@verdocs/web-sdk-react';

export const Auth: React.FC = () => {
  return <VerdocsAuth style={{width: '100%', height: '100%'}} />;
};
